var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAcasa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.87 112.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f333d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.49,86.53c0,6.32-.09,12.64,0,19,.08,4.26-2.2,6.23-6,6.33-8.49.22-17,.08-25.47.25-3,.06-3.09-1.59-3.07-3.81.06-8.15-.1-16.31.09-24.46.1-4.22-1.58-6.21-5.8-6.15-4.66.07-9.32.12-14,0-4.08-.07-5.67,2-5.65,5.86.05,8.15-.17,16.31.13,24.45.13,3.48-1,4.19-4.22,4.09-7.32-.23-14.65,0-22-.14-5.33-.1-7.28-2.06-7.31-7.27-.06-12.31,0-24.62,0-36.94A5.76,5.76,0,0,1,18,63C31.22,49.91,45.84,38.4,59.34,25.65c2-1.94,4.06-2.07,6.13-.15,13.76,12.78,28.83,24,42.32,37.12,1.56,1.51,1.64,3.11,1.64,4.94q0,9.5,0,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.68,21.49c0-3.74,0-7,0-10.33-.06-3.8,1.32-5.93,5.56-5.8,12.66.39,12.34-2,12.29,11.93,0,3.5.4,7.06-.15,10.47-1.26,7.86,1.83,13.38,8.16,17.64a32.3,32.3,0,0,1,5.25,4.6c2.89,3,2.78,6.88-.33,9.68-2.94,2.66-5.85,2.39-8.81-.33-8-7.33-15.78-14.81-24.09-21.71C82,31.39,74.38,25.26,67.29,18.52c-3.65-3.48-6.46-3.16-10.13.21-14.73,13.48-29.69,26.7-44.57,40-4.05,3.63-8.14,3.58-11.19-.1-2.4-2.9-1.74-6.9,2.17-9.91C22.05,34.54,38.49,18,56.2,2.93c4.43-3.77,8.62-4,12.84-.06A187,187,0,0,0,91.68,21.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcasa);
export default __webpack_public_path__ + "static/media/IconAcasa.eb019c8f109651770514ee83916ab653.svg";
export { ForwardRef as ReactComponent };